export const PROFILE_INPUT_BORDER = "#cfcfcf";


export const STATUS_BEGIN = "BEGIN"
export const STATUS_DONE = "DONE"
export const STATUS_FAIL = "FAIL"
export const STATUS_INIT = "INIT"

export const GRN_STATUS_APPROVED = "APPROVED"
export const GRN_STATUS_COMPLETED = "COMPLETED"

export const SELLER_STATUS_APPROVED = "APPROVED"
export const SELLER_STATUS_NON_APPROVED = "NON_APPROVED"
export const SELLER_STATUS_IN_DISPUTE = "IN_DISPUTE"

export const PAYMENT_STATUS_PENDING = "PENDING"
export const PAYMENT_STATUS_NOT_PAID = "NOT_PAID"

export const PO_ORDER_TAG = "DIRECT_DELIVERY"

export const ORDER_STATUS_DISPATCHED = "DISPATCHED"

export const SELLER_ACTION_STATUS_PENDING = "PENDING"
export const SELLER_ACTION_STATUS_COMPLETED = "COMPLETED"
export const SOURCE_DD = "dd"
export const SOURCE_SELLER_HUB = "SELLER_HUB"

export const PO_ORDER_TAG_DIRECT_DELIVERY = "DIRECT_DELIVERY"
export const PO_ORDER_TAG_MANDI_DD = "MANDI_DD"

export const REUPLOAD_VENDOR_INVOICE_STATUS_COMPLETED = "COMPLETED"

export const OSVERSION_WEB = "WEB";

export const HYPERPURE_HELPLINE_NUMBER = "011-41171717";

// Service Purchase Order Source Types
export const SERVICE_PO_SOURCE_PENDING_INVOICES = "PENDING_INVOICES";
export const SERVICE_PO_SOURCE_REJECTED_INVOICES = "REJECTED_INVOICES";
export const SERVICE_PO_SOURCE_LIST_VIEW = "LIST_VIEW";

// Entity Types
export const ENTITY_TYPE_CREDIT_NOTE = "CREDIT_NOTE";
export const ENTITY_TYPE_INVOICE = "INVOICE";
export const ENTITY_TYPE_SELLER_OUTLET = "seller_outlet";

// Invoice Status
export const INVOICE_STATUS_APPROVED = "APPROVED";
export const INVOICE_STATUS_VERIFIED = "VERIFIED";
export const INVOICE_STATUS_PENDING = "PENDING";
export const INVOICE_STATUS_REJECTED = "REJECTED";

// Error Codes
export const ERROR_CODE_BAD_REQUEST = "BAD_REQUEST_ERROR";
export const ERROR_NAME_CANCELED_ERROR = "CanceledError";
export const ERROR_NAME_ABORT_ERROR = "AbortError";
export const ERROR_CODE_ERR_CANCELED = "ERR_CANCELED";

// User Types
export const USER_TYPE_VENDOR = "VENDOR";

// File MIME Types
export const MIME_TYPE_PDF = "application/pdf";
export const MIME_TYPE_IMAGE_JPEG = "image/jpeg";
export const MIME_TYPE_IMAGE_JPG = "image/jpg";
export const MIME_TYPE_IMAGE_PNG = "image/png";

export const GRN_DISPUTE_ISSUE_TYPE = {
    GRN_QUANTITY : "VENDOR_GRN_ISSUE_TYPE_GRN_QUANTITY",
    PRICE_PER_UNIT : "VENDOR_GRN_ISSUE_TYPE_PRICE_PER_UNIT",
    GST_PERCENTAGE : "VENDOR_GRN_ISSUE_TYPE_GST_PERCENTAGE",
};

// GRN OR Filter Values
export const GRN_OR_FILTER_VALUES = {
    SELLER_STATUS_NON_APPROVED: "SELLER_STATUS_NON_APPROVED",
    SELLER_STATUS_APPROVED: "SELLER_STATUS_APPROVED",
    SELLER_STATUS_IN_DISPUTE: "SELLER_STATUS_IN_DISPUTE",
    PAYMENT_STATUS_PAID: "PAYMENT_STATUS_PAID",
};

// Upload Types
export const UPLOAD_TYPE_IMAGE = "image";
export const UPLOAD_TYPE_PDF = "pdf";


// OTP verification constants
export const OTP_LENGTH = 6;
export const RESEND_TIMEOUT = 30;

export const UPDATE_SELLER_STATUS_ENTITY_TYPE = {
    PO_GRN_MAPPING: "PO_GRN_MAPPING",
    PURCHASE_ORDER: "PURCHASE_ORDER"
}

// Warehouse Filter Types
export const GET_WAREHOUSE_FILTER_TYPES = {
  FOR_PURCHASE_ORDER: "FOR_PURCHASE_ORDER",
};

// Purchase Order Status -- backend status
export const PO_STATUS = {
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  WAITING_FOR_VENDOR_APPROVAL: "WAITING_FOR_VENDOR_APPROVAL", 
  PENDING_ADMIN_APPROVAL: "PENDING_ADMIN_APPROVAL",
  APPROVAL_PENDING: "APPROVAL_PENDING" // Old status
};


export const PO_STATUS_APPROVED = "APPROVED";

// 
export const PURCHASE_ORDER_DERIVED_STATUS = {
  UNSCHEDULED: "UNSCHEDULED",
  PARTIALLY_SCHEDULED: "PARTIALLY_SCHEDULED",
  SCHEDULED: "SCHEDULED",
  PARTIALLY_DELIVERED: "PARTIALLY_DELIVERED",
  IN_REVIEW: "IN_REVIEW",
  DELIVERED: "DELIVERED",
  EXPIRED: "EXPIRED",
};
